export * from './delete-bericht.component';
export * from './delete-bericht.component.module';